
  $(document).ready(function() {
    var modal = $('#video-modal');
    var popupVideo = $('#popup-video')[0];
    var muteToggle = $('#mute-toggle');
    var isMuted = true;

    // Video click event
    $('.video-slide a').on('click', function(e) {
      e.preventDefault(); // Prevent default link behavior
      
      // Get video and product URL
      var videoSrc = $(this).data('video');
      var productUrl = $(this).attr('href');
      
      // Set the video source in the modal popup
      popupVideo.src = videoSrc;
      popupVideo.muted = isMuted;
      popupVideo.play();
      
      // Open the modal
      modal.fadeIn();

      // Store the product URL in the modal for redirection later
      modal.data('redirect-url', productUrl);
    });

    // Mute/Unmute functionality
    muteToggle.on('click', function() {
      if (popupVideo.muted) {
        popupVideo.muted = false;
        muteToggle.text('Mute');
      } else {
        popupVideo.muted = true;
        muteToggle.text('Unmute');
      }
    });

    // Close modal when clicking outside the video
    $(document).on('click', function(e) {
      if ($(e.target).is(modal) || $(e.target).is('.close-modal')) {
        popupVideo.pause();
        popupVideo.src = ''; // Clear the video source to stop loading
        modal.fadeOut();
      }
    });

    // Prevent modal from closing when clicking inside the video or buttons
    $('.modal-content').on('click', function(e) {
      e.stopPropagation();
    });

    // Redirect to the product URL when the user clicks a button or element to confirm the redirection
    $('#redirect-to-product').on('click', function() {
      var redirectUrl = modal.data('redirect-url');
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    });
  });




